import React, { useState, useEffect } from "react";
import "./ChairmanProfileModal.css";

const PUBLIC = process.env.PUBLIC_URL || "";

const API_BASE =
    process.env.REACT_APP_API_BASE ??
    (process.env.NODE_ENV === "production"
        ? "https://api.soaltriskelions.com"
        : "http://localhost:5000");

export default function ChairmanProfileModal({
    list,
    index,
    onClose,
    onPrev,
    onNext
}) {
    /* ===================== STATE (ALWAYS FIRST) ===================== */
    const [zoomOpen, setZoomOpen] = useState(false);
    const [photoSrc, setPhotoSrc] = useState(null);

    /* ===================== DERIVED DATA ===================== */
    const hasData = Array.isArray(list) && list[index];
    const m = hasData ? list[index] : null;

    const realPhoto = m
        ? `${API_BASE}/api/legacy/photo/${encodeURIComponent(m.primaryid)}`
        : null;

    const fallbackPhoto = `${PUBLIC}/images/default-chairman.png`;

    /* ===================== IMAGE PRELOAD ===================== */
    useEffect(() => {
        if (!realPhoto) {
            setPhotoSrc(null);
            return;
        }

        let alive = true;
        const img = new Image();

        img.src = realPhoto;
        img.onload = () => alive && setPhotoSrc(realPhoto);
        img.onerror = () => alive && setPhotoSrc(fallbackPhoto);

        return () => {
            alive = false;
        };
    }, [realPhoto, fallbackPhoto]);

    /* ===================== RENDER GUARD (AFTER HOOKS) ===================== */
    if (!hasData) return null;

    /* ===================== RENDER ===================== */
    return (
        <>
            <div className="chairman-modal-overlay">
                <div className="chairman-modal">
                    <button className="chairman-close" onClick={onClose}>
                        ✖
                    </button>

                    {photoSrc && (
                        <img
                            src={photoSrc}
                            alt={`${m.firstname} ${m.lastname}`}
                            className="chairman-photo"
                            onClick={() => setZoomOpen(true)}
                        />
                    )}

                    <h3>{m.firstname} {m.lastname}</h3>

                    <p><strong>Root Chapter:</strong> {m.rootchapter}</p>
                    <p><strong>Year Served:</strong> {m.yearserved}</p>

                    <div className="chairman-nav">
                        <button onClick={onPrev} disabled={index === 0}>
                            ◀ Prev
                        </button>
                        <button
                            onClick={onNext}
                            disabled={index === list.length - 1}
                        >
                            Next ▶
                        </button>
                    </div>
                </div>
            </div>

            {zoomOpen && (
                <div
                    className="zoom-overlay"
                    onClick={() => setZoomOpen(false)}
                >
                    <img src={photoSrc} alt="Zoomed portrait" />
                    <span className="zoom-close">Tap anywhere to close</span>
                </div>
            )}
        </>
    );
}
